import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { SafeResourceUrl } from '@angular/platform-browser';

import _moment from 'moment';
import { AbstractControl, FormControl } from '@angular/forms';
import { AppConstMessages } from './app.const.messages';

@Injectable()
export class AppConstant extends AppConstMessages {

  //API Level
  public APIUrl = environment.APIUrl + 'api/';
  public MIMSAPIUrl = environment.MIMSAPIUrl + 'api/';
  public Interval = environment.interval;
  public SiteURL = environment.SiteURL;
  public powerbiReportURl = environment.powerbiReportURl;
  public powerbiDashboardURl = environment.powerbiDashboardURl;
  public powerbiTileURl = environment.powerbiTileURl;
  public powerBiReport = "report";
  public powerBiDashboard = "dashboard";

  public GoogleAPIKey = environment.GoogleAPIKey;
  //Site Level
  public ProgramSetupTabList = [
    { name: 'Program Information', key: 'programinfo', isActive: true },
    { name: 'Products', key: 'product', isActive: null },
    { name: 'Module Subscription', key: 'modulesubscription', isActive: null },
    { name: 'Role Management', key: 'rolemgt', isActive: null },
    { name: 'Menu Management', key: 'insightmenu', isActive: null },
    { name: 'Program Users', key: 'programusers', isActive: null },
    { name: 'Program Reports', key: 'programreports', isActive: null }
  ];

  public userDetail;
  public shipmentDetail;//for shipment

  public config = {
    tenant: environment.tenant,
    clientId: environment.clientId,
    redirectUri: environment.redirectUri,
    endpoints: environment.endpoints,
    navigateToLoginRequestUrl: false,
    cacheLocation: environment.cacheLocation,
    expireOffsetSeconds: 3000
  }

  public roleContext = { Admin: "Admin", Manager: "Manager", CustomerAdmin: "CustomerAdmin", CustomerUser: "CustomerUser" };
  public EnumLocationType = { code1: "code1", code2: "code2" };

  public SAMPLING_PLAN_STATUS = { draft: "draft", scheduled: "scheduled", active: "active", executed: "executed", close: "close" };
  public CASE_STATUS = { new: "new", progress: "progress", close: "close" };
  public CASE_TYPE = { wholesaler: "wholesaler", terminal: "terminal" };
  public MENU_IDENTIFIER = { insightMenu: 1, adminMenu: 2 }


  //Program Level
  public programId = '';
  public programName: string = '';
  public isShowStepProgress: boolean = true;
  public country = [];
  public location = [];
  public ProgramType = [];
  public ProgramAdminUser = [];
  public ProductType = [];
  public ProductCategory = [];
  public ModuleList = [];
  public ConcentrationUnits = [];
  public DosingLevelUnits = [];
  public programUserRoles = [];
  public roleContextProgramUsers = [];
  public programUserLanguage = [];
  public programUserId = '';
  public userID = '';

  public LocationId = '';
  public SamplingPlanId = '';
  public SamplingPlanName = '';
  public SamplingStatusCode = '';
  public programDataSource: any = [];
  public selectedProgramId = '';
  public CaseId = '';
  public CaseName = '';
  public CaseCreatedByName = '';
  public ReportId: string = "";
  public ReportGroupId: string = "";
  public isCallFromProgramUser = false;
  public userProgramDatasource: any = [];
  public userModuleAccessDatasource: any = [];
  public selectedHeaderProgramText: string = '';
  public isUserProgramAdmin = false;
  public logInAsProgramContext: boolean = false;
  public isUserAuthorizeCallCompleted: boolean = false;
  public isReportSubscription: boolean = true;
  public ShowAdminDashboard: boolean = true;
  public TokenExpiresIn: any = new Date();
  public isReport: boolean = true;
  public insightMenusafeSrc: SafeResourceUrl;
  public mainInsightMenu: any = {};
  public adminMenu: any = {};
  public loadInsightMenu: boolean = true;


  public subMarkerInventoryMenus = [];
  public mimsUserID = '';
  public mimsDecatingId = '';
  public mimsSourceContainerNumber = '';
  public mimsDestinationDecantId = '';
  public mimsDestinationContainerNumber = '';
  public decantDocuments: any;
  public mimsShipmentID = ''; //for shipments
  public ShipmentId = '';
  public marker = [];
  public MarkerId = "";
  public shipmentExpectedItemId = "";
  public mimsReceiptdrumtId = '';
  public mimsContainerId = '';
  public mimsMarkerBlendsId = '';
  public mimsMarkerLocationId = '';
  public mimsDrumDisposalId = '';
  public mimsProductId = '';
  public mimsDispatchId = '';
  public mimsDispatchOrder = '';
  public mimsMarkerDispatchId = '';
  public mimsMarkerDispatch = '';
  public mimsContainerDispatchId = '';
  public mimsContainerDispatch = '';
  public emptyGuid = '00000000-0000-0000-0000-000000000000';
  public userType = 0;
  public productcategory = [];
  public locationType = [];

  public mimsMarkingOperationCompartmentId = '';
  public mimsNextCompartmentNumber = 1;
  public mimsDisposalId = '';
  public mimsDisposalContainerName = '';
  public disposalDocuments: any;
  public mimsLockerId = '';
  public mimsLockerName = '';
  public mimsLockerContainerId = '';
  public mimsMarkingOpeartionId = '';
  public mimsBulkDistributionId = '';
  public mimsOilMarketingCompanyId = '';
  public mimsInventoryId = '';
  public mimsInventorySubTitle = '';
  public mimsInventoryItemId = '';
  public mimsRoleId = '';
  public mimsdeleteConfirmIndex = -1;
  public mimsMarkingOperationSubTitle = '';
  public mimsAppSettings: any = [];
  public mimsFieldTestId ='';
  public mimsFieldTestCompartmentId= '';
  public mimsProductDecimalPlaces = '';
  public mimsMarkerDecimalPlaces = '';
  public getValidationMessage(error) {
    let strMessage = '';
    if (error.error.message && error.error.message.length > 5) {
      strMessage = error.error.message;
    } else if (error.error.errors) {
      var ers = error.error.errors;
      for (var item in ers) {
        strMessage = strMessage + ers[item] + '\n\r';
      }
    } else {
      strMessage = error.message;
    }
    return strMessage;
  }

  public moment = _moment;
  convertUTCToLocal(value) {
    var date = this.moment.utc(value).format('YYYY-MM-DD HH:mm:ss');
    var stillUtc = this.moment.utc(date).toDate();
    var local = this.moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss');

    return new Date(local);
  }
  public getlocaltime() {
    let Time = this.moment().format("HH:mm");
    return Time;
  }

  convertToStrDate(tempDate: Date) {
    if (typeof tempDate === "string") {
      tempDate = new Date(tempDate);
    }
    const utcDate: any = this.moment.utc(tempDate.getFullYear() + "-" + ("0" + (tempDate.getMonth() + 1)).slice(-2) + "-" + ("0" + tempDate.getDate()).slice(-2));
    return (utcDate._i);
  }

  convertToTimeFormat(value: any) {
    if (value) {
      let splArray = value.split(':');
      if (splArray.length > 1) {
        return splArray[0] + ":" + splArray[1];
      }
    }
    return value;
  }
  getValueToDecimal(value) {
    let conv_value = 0;
    if (value) {
      conv_value = value;
    }
    return conv_value.toFixed(2);
  }
  generateMarkingOperationNumber() {
    var utcMoment = this.moment.utc();
    var utcDate = new Date(utcMoment.format('YYYY-MM-DD HH:mm:ss:SSS'));
    var firstDayOfMonth = new Date(utcDate.getFullYear(), utcDate.getMonth(), 1);

    var date1_ms = firstDayOfMonth.getTime();
    var date2_ms = utcDate.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
    return utcMoment.format('YYMM') + '-' + difference_ms;
  }
  generateOrderNumber() {
    var utcMoment = this.moment.utc();
    var utcDate = new Date(utcMoment.format('YYYY-MM-DD HH:mm:ss:SSS'));
    var firstDayOfYear = new Date(utcDate.getFullYear(), 0, 1);

    var date1_ms = firstDayOfYear.getTime();
    var date2_ms = utcDate.getTime();

    // Calculate the difference in milliseconds
    var difference_ms = date2_ms - date1_ms;
    return utcMoment.format('YYMM') + '-' + difference_ms;
  }
  //get current date
  getLocalCurrentDate() {
    return new Date();
  }
  //get max date for all date pickers which not have any max date field
  getmaxYearDate(){
    return new Date(3000,0,1);
  }
  public noWhitespaceValidator(control: AbstractControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    if (!isWhitespace) {
      let actulLen = (control.value || '').length;
      let neesLen = (control.value || '').replace(/\s/g, '').length;
      if (neesLen != actulLen) {
        isWhitespace = true;
      }
    }
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  //not allow to enter only space in textbox
  public OnlyWhiteSpaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  public getAppSettingByParameter(parameterName: any) {
    return this.mimsAppSettings.filter(x => x.parameter.toLocaleLowerCase() == parameterName.toLocaleLowerCase()).map(x => x.parameterValue)[0];
  }

  public isValidateDiscrepancy(minValue: number, maxValue: number, discrepancyValue: number) {
    if (discrepancyValue <= maxValue && discrepancyValue >= minValue) {
      return true;
    }
    else {
      return false;
    }
  }

  ListOfMethod = ['GetProductMarkersByProductId', 'GetEditProgramDetails', 'ManageProgram', 'DeleteProgramById', 'ManageProgramStatus',
    'GetProgramProductDetail', 'GetProgramProductsByProgramId', 'UpdateProgramProductDetail', 'DeleteProductById', 'ManagerProduct', 'GetRoles',
    'DeleteRole', 'ManageStatus', 'GetPermission', 'ManagePermission', 'GetSubscription', 'ManageSubscription', 'GetProgramUsers', 'GetProgramUserDetailById',
    'ManageProgramUser', 'ManageProgramUserStatus', 'DeleteProgramUserById', 'AssignProgramUser', 'GetAllRoles', 'GetLocations', 'GetLocationSearch',
    'GetLocationDetails', 'ManageLocation', 'ManageLocationStatus', 'DeleteLocation', 'GetProgramRoles', 'GetProgramUsersAndAdmin', 'GetModuleDetailByProgramId',
    'GetProgramDetailByUserAndProgram', 'PreviewLocations', 'ExportLocations', 'GetSamplingPlans', 'DeleteSamplingPlan', 'GetStatusList', 'GetSampleStatusType',
    'ManageSamplingPlan', 'GetSamplingPlan', 'GetSamplingPlanLocations', 'ManageSamplePlanLocation', 'GetVisitedLocations', 'GetAllCollectedSample', 'GetLocationsByFilter',
    'PreviewSampleLocations', 'ExportSampleLocations', 'RemoveSampleLocations', 'GetSamplingPlanUsers', 'GetSamplingPlanProducts',
    'ManageSamplingPlanProduct', 'ManageSamplePlanUser', 'DeleteUserById', 'GetAllCases', 'GetProgramCase', 'GetCaseStatusAndType', 'ManageCase', 'GetCaseSuggestion', 'GetProgramCaseSampleByCaseId', 'ManageCaseSample',
    'GetHistoricCases', 'CaseDocumentUpload', 'GetProgramCaseSamplingPlanNames', 'GetProgramCaseSamplesByFilter', 'GetDocuments', 'DeleteCase', 'RemoveCaseSample', 'DownloadFile', 'DeleteCaseDocument',
    'GetAnswersByCaseId', 'ManageCaseQuestionAnswer', 'GetAllReports', 'ManageProgramReport', 'DeleteReport', 'ManageProgramReportStatus', 'GetReportById',
    'GetSamplingPlanHeaderDetails', 'GenerateSamplingReport', 'GetCaseSampleStatus', 'GetActiveRoles', 'ManageInsightMenu', 'GetInsightMenu', 'DeleteInsightMenu', 'ManageUserStatus', 'DeleteUserByRefId',
    'Shipments', 'DeleteShipment', 'ManageShipment', 'ShipmentDetailById', 'ShipmentDrums', 'DeleteShipmentDrum', 'Markers', 'ManageShipmentDrum', 'ShipmentDrumById',
    'DeleteDestinationDecantByRefId', 'Decanting', 'Decants', 'DeleteDecantByRefId', 'DestinationDecantingById', 'DestinationDecanting', 'ContainerTypes', 'Markers', 'UploadDecantingFiles', 'DestinationDecantingByDecandingId', 'DeleteDecantingDocument',
    'ManageReceipt', 'ReceiptDrums', 'DeleteReceiptDrum', 'ShipmentReceiptById', 'ReceiptDrumById', 'Documents', 'DeleteDocument', 'UploadDocument', 'ManageReceiptDrum', 'items', 'all', 'delete', 'create', 'containertypes', 'markerblend', 'update', 'drumdisposaltypes',
    'dispatches', 'dispatchDetailById', 'deleteDispatch', 'manageDispatch', 'markers', 'markerDetailById', 'deleteMarker', 'manageMarker', 'containers', 'containerDetailById', 'deleteContainer', 'manageContainer', ''
    , 'documents', 'uploadDocument', 'deleteDocument', 'managemarkingoperation'
    , 'managemarkingoperationtype', 'markingoperationtypes'
    , 'ShipmentDrumByIdAndDrum', 'products', 'country', 'markerlocations',
    'disposallist', 'manageremovalcontainerdisposal', 'managecontainerdisposal', 'uploadfiles', 'deletedocument', 'deletedisposal', 'containerdisposal', 'disposallist', 'documents', 'containerdisposal', 'lockers', 'deletelocker', 'locker', 'managelockeraccess', 'lockercontainers', 'deletelockercontainer'
    , 'managecontainer', 'lockercontainerdetail', 'oilmarketingcompanies', 'managebulkdistributioncompany', 'bulkdistributioncompanies', 'manageoilmarketingcompany', 'inventories', 'deleteinventory', 'inventory', 'manageinventory'
    , 'deleteitem', 'manageitem', 'item', 'roles', 'deleterole', 'getmodules', 'getpermission', 'managerole', 'allresources'
    , 'markingcompartments', 'deletecompartment', 'markingcompartment', 'managemarkingcompartment', 'markingoperations', 'appsettings',
    'markingoperation', 'deletemarkingoperation', 'GetMarkingOperationsByPage',
    'fieldtests','fieldtest','deletefieldtest','allresources','managefieldtest','deletefieldtestcompartment',
    'shipmentexpecteditems','deleteshipmentexpecteditem','manageshipmentexpecteditem','shipmentexpecteditemsbyid'
    ,'updateappsetting','duplicatemarkingoperations', 'GetMarkingOperationYears', 'GetMarkingOperationMonths', 'SetMarkingOperationMonth'
    ,'fieldtestcompartments','managefieldtestcompartment','fieldtestcompartment','ManageProgramUserDetails','dispatch','users','user'
  ];

  FileUploadListMethodsWithProgram = ['Decanting', 'ManageShipment', 'DestinationDecanting', 'UploadDecantingFiles', 'UploadDestinationDecantingFiles', 'CaseDocumentUpload', 'ManageReceiptDrum', 'UploadDocument', 'uploadDocument', 'manageContainer', 'managecontainerdisposal', 'uploadfiles', 'uploadfiles', 'documents', 'manageremovalcontainerdisposal', 'managecontainerdisposal'
    , 'manageitem', 'GetMarkingOperationYears', 'GetMarkingOperationMonths', 'SetMarkingOperationMonth'];
}
